module.exports = __webpack_public_path__ + "img/error.8a4288a5.png";